import {Component, Input} from '@angular/core';
import {ChartDataset, ChartOptions, ChartType} from 'chart.js';
import {CompetitiveIntelligenceStudy} from './competitive-intelligence-study';
import {TeamData} from './team-data';
import {ChartUtils} from '../chart-utils';

@Component({
    selector: 'kiwi-competitive-intelligence',
    templateUrl: './competitive-intelligence.component.html',
    styleUrls: ['./competitive-intelligence.component.scss'],
    host: { 'class': 'cell auto grid-y' },
    standalone: false
})
export class CompetitiveIntelligenceComponent {
    @Input()
    comparisonTitleLabel: string;

    @Input()
    barChartLabel: string = '';

    @Input()
    teamValueLabelKey: string;

    @Input()
    set comparisonStudy(study: CompetitiveIntelligenceStudy) {
        if (study) {
            this.barChartData = study.chartDataSets;
            this.customizeColors();
            this.teamsData = study.teamsData;
        }
    }

    public barChartType: ChartType = 'bar';
    public barChartLegend = true;
    public barChartOptions: ChartOptions = {
        indexAxis: 'y',
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    callback: (value) => {
                        return value.toLocaleString();
                    }
                }
            }
        },
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    font: {
                        size: 14
                    }
                }
            }
        }
    };

    public chartColors: Array<string> = [
        'rgba(145, 79, 56, 1)',
        'rgba(192, 117, 91, 1)',
        'rgba(180,173,173, 1)',
        'rgba(90, 94, 107, 1)',
        'rgba(218, 143, 107, 1)',
        'rgba(192, 197, 193, 1)',
        'rgba(247, 227, 175, 1)',
        'rgba(39, 40, 56, 1)',
        'rgba(209, 157, 137, 1)',
        'rgba(98, 48, 24, 1)',
    ];

    public barChartData: Array<ChartDataset> = [{data: null}];
    public teamsData: TeamData[];

    private customizeColors(): void {
        this.barChartData.forEach((barChartData, index) => {
            ChartUtils.customizeColor(barChartData, this.chartColors[index % this.chartColors.length]);
        });
    }
}
